module.exports = __webpack_public_path__ + "static/media/B_S03.6c8fbd53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/RED/B_S03.png
// module id = 120
// module chunks = 0